import React, { PureComponent, Fragment } from 'react';

import Button from '@material-ui/core/Button';

import { FAST_ANIMATION } from '../../../ws/constants';

class ModalBox extends PureComponent {
    state = {
        isVisible: false
        , okLabel: this.props.okLabel || "OK"
        , cancelLabel: this.props.cancelLabel || "Cancelar"
        , confirmModal: this.props.confirmModal || false
        , returnType: this.props.returnType || 1 //1 success, 2 error
    };

    componentDidMount() {
        setTimeout(() => {
            document.body.classList.add("modalOpen");
            this.setState({isVisible:true});
        }, FAST_ANIMATION);
    }

    componentWillUnmount(){
        document.body.classList.remove("modalOpen");
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.returnType !== nextProps.returnType) {
            this.setState({returnType: nextProps.returnType});
        }
    }

    handleOk = (e) => {
        console.log("handleOk", this.props.modalCallBack);
        if(this.props.modalCallBack){
            setTimeout(() => {
                this.props.modalCallBack(true, false, this.state.returnType); // 1st param should be the result whilst the second should be (keepModalOpen)
            }, FAST_ANIMATION);
        }
    }

    handleCancel = (e) => {
        console.log("handleCancel", this.props.modalCallBack);
        if(this.props.modalCallBack){
            setTimeout(() => {
                this.props.modalCallBack(false, false, this.state.returnType); // 1st param should be the result whilst the second should be (keepModalOpen)
            }, FAST_ANIMATION);
        }
    }

    render() {
        var activeClass = this.state.isVisible ? " active" : ""
            , modalClass = this.props.modalClass ? ` ${this.props.modalClass}` : ""
            , bigModalClass = this.props.bigModal ? " bigModal" : ""
            , noOverlayClass = this.props.noOverlay ? " noOverlay" : "";

        return (
            <Fragment>
                <div className={"modalBox" + activeClass + bigModalClass + modalClass + noOverlayClass}>
                    <button type="button" className="simpleBtn closeModal" onClick={this.handleCancel}><i className="fa fa-times"></i></button>
                    <div className="row">
                        {this.props.modalHtml}
                        { !this.props.hideButtons &&
                            <div className="col-12 buttonsHolder text-center">
                                { this.state.confirmModal &&
                                    <Button onClick={this.handleCancel} className="float-left" variant="contained">{this.state.cancelLabel}</Button>
                                }
                                <Button onClick={this.handleOk} className={this.state.confirmModal ? "float-right" : ""} variant="contained" color="primary">{this.state.okLabel}</Button>
                            </div>
                        }
                    </div>
                </div>
                {!this.props.noOverlay && <div className={"darkOverlay " + activeClass}></div>}
            </Fragment>
        );
    }
}

export default ModalBox;
